import {
    Loading,
    UserLogin,
    UserLoginError

} from './Actions';

import {SERVER_HOST} from '../../auth/Configs';
import axios from 'axios';

const Api = SERVER_HOST;

export const GetUserToken = (user, navigate)=>{
   
    return dispatch =>{

        dispatch(Loading())
        //get user token
        axios.post(`${Api}/accounts/login`, user).then( response=> {

           const valideToken = response.data.token ;

            if(valideToken){

            //get current user
            let configs = {
                methods: 'GET',
                url: Api+'/user/datas',
                headers:{
                    'Authorization': 'Bearer '+valideToken
                }
            }

            axios(configs).then(response =>{

                if(response.status === 200){

                    const currentUser = { token: valideToken, res: response.data }
                    //console.log(currentUser)
                    dispatch(UserLogin(currentUser))
                    //redirection page admin
                    navigate(`/apps/in/dashboard/${response.data.useruuid}`, {replace: true});

                }
            }).catch(err =>{
                dispatch(UserLoginError(err))
            });
        
        }//end valid token

        })
        .catch(error=>{
            dispatch(UserLoginError(error))
        });
    }

 //end dispachs   
};

